@if (!isSizeLocationsEmpty) {
<form [formGroup]="selectLocationtForm" class="select-location">
    <h-select-input
        id="select-location"
        [name]="'sizeLocation'"
        [controlName]="'sizeLocation'"
        [selectedOptionValue]="selectedCountry ?? ''"
        [options]="countryListOption"
        i18n-label="hermes.size_guide.select_a_location"
        label="Select a location">
    </h-select-input>
</form>
}

<h-block-table [content]="tablesData"></h-block-table>
